import { render } from "./ErrorBag.vue?vue&type=template&id=f1f05888"
import script from "./ErrorBag.vue?vue&type=script&lang=js"
export * from "./ErrorBag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__